import { decryptData } from "@flexibees/core";
import { API } from "../constants/api";
import {
  axiosGetWithToken,
  axiosMediaUpload,
  axiosPut,
  axiosPostWithToken,
} from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";

export const PROJECT_DETAILS_FROM_CRM = "PROJECT_DETAILS_FROM_CRM";
export const PROJECT_DETAILS = "PROJECT_DETAILS";
export const GET_ROLES = "GET_ROLES";
export const GET_SKILLS = "GET_SKILLS";
export const GET_DOMAINS = "GET_DOMAINS";
export const GET_LANGUAGES = "GET_LANGUAGES";
export const UPDATE_PROJECT_DETAILS_FROM_CRM =
  "UPDATE_PROJECT_DETAILS_FROM_CRM";
export const UPDATE_PROJECT_DETAILS = "UPDATE_PROJECT_DETAILS";
export const GET_DYNAMIC_DROPDOWN_FROM_CONFIG =
  "GET_DYNAMIC_DROPDOWN_FROM_CONFIG";

export const getRolesFromConfig = () => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    axiosGetWithToken(`${API.GET_ADMIN_ROLES}`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: GET_ROLES,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        console.log("ERR", err);
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong.",
        });
      });
  };
};
export const getDynamicDropdownFromConfig = () => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const body = {};
    axiosPostWithToken(`${API.GET_DYNAMIC_DROPDOWN_FROM_CONFIG}`, body, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          console.log("HERE DATA",res.data.data)
          dispatch({
            type: GET_DYNAMIC_DROPDOWN_FROM_CONFIG,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        console.log("ERR", err);
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong.",
        });
      });
  };
};

export const updateCrmDetails = (id, bodyData, refreshProjectDetails) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const projectId = decryptData(id);

    axiosPut(`${API.FROM_CRM}/${projectId}/`, bodyData, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          // update crm details
          dispatch({
            type: UPDATE_PROJECT_DETAILS_FROM_CRM,
            payload: res.data.data,
          });
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Updated Successfully",
          });
          refreshProjectDetails();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload: err.response.data || "Something went wrong.",
        });
      });
  };
};

export const getCrmDetails = (id, disableLoader) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const projectId = decryptData(id);
    console.log("PROJECT ID", projectId);
    axiosGetWithToken(`${API.FROM_CRM}/${projectId}/`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: PROJECT_DETAILS_FROM_CRM,
            payload: res.data.data,
          });
          disableLoader();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload: err.response.data || "Something went wrong.",
        });
      });
  };
};

export const getProjectDetails = (id) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const projectId = decryptData(id);

    axiosGetWithToken(`${API.PROJECT}/${projectId}/`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: PROJECT_DETAILS,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload: err.response.data || "Something went wrong.",
        });
      });
  };
};

export const getSkillsFromConfig = (func) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    axiosGetWithToken(`${API.GET_ADMIN_SKILLS}`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: GET_SKILLS,
            payload: res.data.data.filter((skill) => skill.function === func),
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        console.log("ERR", err);
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong.",
        });
      });
  };
};

export const getDomainsFromConfig = () => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    axiosGetWithToken(`${API.GET_ADMIN_DOMAINS}`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: GET_DOMAINS,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        console.log("ERR", err);
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong.",
        });
      });
  };
};

export const getLanguages = () => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    axiosGetWithToken(`${API.GET_LANGUAGES}`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: GET_LANGUAGES,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        console.log("ERR", err);
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong.",
        });
      });
  };
};

export const updateProjectDetails = (id, bodyData, refreshCRMDetails) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const projectId = decryptData(id);

    axiosPut(`${API.PROJECT}/${projectId}/`, bodyData, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          // update crm details
          dispatch({
            type: UPDATE_PROJECT_DETAILS,
            payload: res.data.data,
          });
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Updated Successfully",
          });
          refreshCRMDetails();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload: err.response.data || "Something went wrong.",
        });
      });
  };
};
export const uploadAssignment = (file, update) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    axiosMediaUpload(API.MEDIA_UPLOAD, "pdf", file, token).then((res) => {
      if (res.data.status_code === 200) {
        update(res.data.data);
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Assignment has uploaded successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res.data.data.message,
        });
      }
    });
  };
};
